import { styled } from '@mui/material';

import { datePickerClasses } from './theme';

/**
 * DateTimeRangePicker와 InlineDateTimeRangePicker에서 사용하는
 * 날짜 범위 구분자 컴포넌트 (~)
 */
export const Separator = styled('span', {
  target: datePickerClasses.separator,
  shouldForwardProp: prop => prop !== 'hasLabel' && prop !== 'size',
})<{ hasLabel: boolean; size: 'sm' | 'md' | 'lg' }>`
  display: flex;
  align-items: center;
  padding-top: ${({ size, hasLabel }) => {
    if (!hasLabel) {
      return '0';
    }
    // FormField label padding-top + label min-height + label padding-bottom + margin-bottom
    switch (size) {
      case 'sm':
        // 4px (label padding-top) + 20px (label height) + 4px (label padding-bottom) + 2px (margin) = 30px
        return '30px';
      case 'lg':
        // 6px (label padding-top) + 24px (label height) + 6px (label padding-bottom) + 2px (margin) = 38px
        return '38px';
      case 'md':
      default:
        // 6px (label padding-top) + 21px (label height) + 6px (label padding-bottom) + 2px (margin) = 35px
        return '35px';
    }
  }};
  line-height: ${({ size }) => {
    // Input height - "~" 문자가 input의 중앙에 위치하도록 line-height 설정
    switch (size) {
      case 'sm':
        return '28px'; // lg input height
      case 'lg':
        return '40px'; // lg input height
      case 'md':
      default:
        return '32px'; // sm input height
    }
  }};
`;
